/* eslint-disable */
import React from 'react';
import { Button, Form } from "react-bootstrap";
import Loader from "react-loader-spinner";
import { Card, CardBody, CardHeader, CardHeaderToolbar } from "../../../_metronic/_partials/controls/Card";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip
} from "recharts";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import * as Api from "../../General/api";
import * as Common from "../../General/common";
import uuid from 'node-uuid';
import moment from 'moment';
import Select, { createFilter } from "react-select";
import { showSuccessAlertAutoClose } from '../../General/common';
import { documentationFilterType } from '../../General/documentation-filter.enum';

function resolveExudateAmountId(w, exudateMap) {
  if (w.amount != null && w.amount !== '') return w.amount;
  if (w.fkExudateAmountId != null && w.fkExudateAmountId !== '') return w.fkExudateAmountId;
  if (w.exudateAmountName != null && exudateMap && exudateMap[w.exudateAmountName] != null) return exudateMap[w.exudateAmountName];
  return null;
}

export default class WoundAreaTrendReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      facilityName: null,
      residentName: null,
      woundType: null,
      facilityList: [],
      facilityResidentList: [],
      residentWoundList: [],
      IsLoading: false,
      showReport: false,
      facilityForPDFName: null,
      wound: {
        residentId: null,
        woundId: null,
        fromDate: "",
        toDate: ""
      },
      summary: {
        patientName: '',
        providerName: '',
        woundLocation: '',
        woundType: '',
        reportGeneratedDate: null
      },
      reportRows: [],
      selectedMetric: 'area'
    }
  }
  componentDidMount() {
    this.getAllFacility();
  }
  getAllFacility() {
    Api.getRequest(`${Api.Uri_GetFacility}?isAssessmentView=1`,)
      .then((res) => {

        if (res.data.statusCode == 200) {
          if (res.data.result != null) {

            if (res.data.result.length > 0) {
              
              let facilityList = res.data.result.map(facility => ({ value: facility.id, label: facility.facilityName })).sort((a, b) => a.label.localeCompare(b.label));

              // let facilityList = res.data.result.map(v => (
              //   <option key={v.id} value={v.id}>
              //     {v.facilityName}
              //   </option>
              // ));
              this.setState({ facilityList: facilityList, IsLoading: true })
            }
          }
        }
      }).catch((ex) => {
      });
  }
  onFacilitiChange = (e) => {
    this.setState({
      facilityResidentList: [],
      residentWoundList: [],
      residentName: null,
      woundType: null,
      facilityName: e,
      wound: { ...this.state.wound, residentId: null, woundId: null }
    });
    if (e) {
      Api.getRequestQry(Api.Uri_GetResidentByFacilityId, `?facilityId=${e.value}`)
        .then((res) => {
          if (res.data.statusCode === 200 && res.data.result != null && res.data.result.length > 0) {
            const data = res.data.result.map((item) => ({ value: item.key, label: item.value })).sort((a, b) => a.label.localeCompare(b.label));
            this.setState({ facilityResidentList: data });
          }
        })
        .catch((ex) => { Common.LogError(ex, "ResidentByFacility", "Get"); });
    }
  }

  onResidentChange = (e) => {
    this.setState({
      residentWoundList: [],
      woundType: null,
      residentName: e,
      wound: { ...this.state.wound, residentId: e ? e.value : null, woundId: null }
    });
    if (e) {
      Api.getRequestQry(Api.URI_GetResidentWoundByResidentID, `?id=${e.value}&isDocumentationOnly=${documentationFilterType.Both}`)
        .then((res) => {
          if (res.data.statusCode === 200 && res.data.result != null && res.data.result.length > 0) {
            const residentWoundList = res.data.result.map((element) => ({
              value: element.wound.id,
              label: `[${element.wound.isOpen ? 'Open' : 'Closed'}] ${moment(element.wound.evaluationDate).format('MM/DD/YYYY')} - ${element.wound.orientationLeftRightName ? element.wound.orientationLeftRightName + ' - ' : ''}${element.wound.bodyRegion || ''}${(element.wound.bodyRegion && element.residentWoundLocation) ? '/' : ''}${element.residentWoundLocation || ''}`
            })).sort((a, b) => a.label.localeCompare(b.label));
            this.setState({ residentWoundList });
          }
        })
        .catch((ex) => { Common.LogError(ex, "ResidentWound", "Get"); });
    }
  }
  handleSubmit = (event) => {
    event.preventDefault();
    const obj = this.state.wound;
    if (!obj.woundId || !obj.residentId || !obj.fromDate || !obj.toDate) {
      showSuccessAlertAutoClose('Please select Facility, Resident, Wound, From Date, and To Date.', 'warning', 'Warning!', 3000);
      return;
    }
    if (obj.fromDate > obj.toDate) {
      showSuccessAlertAutoClose('From Date must be on or before To Date.', 'warning', 'Warning!', 3000);
      return;
    }
    this.setState({ showReport: false, facilityForPDFName: this.state.facilityName ? this.state.facilityName.label : '' });
    const query = `?fromDate=${encodeURIComponent(obj.fromDate)}&toDate=${encodeURIComponent(obj.toDate)}&residentId=${obj.residentId}&woundId=${obj.woundId}`;
    Api.getRequestQry(Api.Uri_GetRptWoundAreaTrend, query)
      .then((res) => {
        if (res.data.statusCode !== 200 || res.data.result == null) {
          showSuccessAlertAutoClose('Record not found', 'warning', 'Warning!', 3000);
          this.setState({ showReport: false });
          return;
        }
        const raw = res.data.result;
        const rows = Array.isArray(raw) ? raw : (raw ? [raw] : []);
        const fromM = moment(obj.fromDate).startOf('day');
        const toM = moment(obj.toDate).endOf('day');
        const woundBlock = rows.length > 0 ? rows[0] : null;
        const details = woundBlock ? (woundBlock.woundEvaluationDetail || []) : [];
        const filtered = details.filter((d) => {
          const dM = moment.utc(d.evaluationDate).local();
          return dM.isSameOrAfter(fromM) && dM.isSameOrBefore(toM);
        });
        const exudateMap = Common.exudate ? { Light: Common.exudate.light, Moderate: Common.exudate.moderate, Heavy: Common.exudate.heavy } : {};
        const reportRows = filtered
          .map((w) => {
            const len = Number(w.woundLength);
            const wd = Number(w.woundWidth);
            const area = (isNaN(len) ? 0 : len) * (isNaN(wd) ? 0 : wd);
            const exudateAmountId = resolveExudateAmountId(w, exudateMap);
            const hasPush = exudateAmountId != null && w.fkWoundSevereTissueTypeId != null;
            const pushScore = hasPush ? Common.calculatePushScore(area, exudateAmountId, w.fkWoundSevereTissueTypeId) : null;
            return {
              date: w.evaluationDate,
              dateLabel: Common.getInputStringDateUsingMoment2(moment.utc(w.evaluationDate).local()),
              length: isNaN(len) ? (w.woundLength != null ? w.woundLength : 'N/A') : len,
              width: isNaN(wd) ? (w.woundWidth != null ? w.woundWidth : 'N/A') : wd,
              area,
              pushScore
            };
          })
          .sort((a, b) => new Date(a.date) - new Date(b.date));
        const providerName = woundBlock ? (woundBlock.physicianName || woundBlock.physicanName || '') : '';
        const summary = {
          patientName: woundBlock ? (woundBlock.residentName || '') : '',
          providerName,
          woundLocation: woundBlock ? (woundBlock.woundLocation || '') : '',
          woundType: woundBlock ? (woundBlock.woundType || '') : '',
          reportGeneratedDate: moment()
        };
        this.setState({
          summary,
          reportRows,
          showReport: true
        });
        if (reportRows.length === 0) {
          showSuccessAlertAutoClose('No assessments found in the selected date range.', 'info', 'Info', 3000);
        }
      })
      .catch((ex) => {
        showSuccessAlertAutoClose('Sorry, an error has occurred.', 'warning', 'Warning!', 3000);
        Common.LogError(ex, "WoundAreaTrend", "Get");
        this.setState({ showReport: false });
      });
  }

  handleClearFilters = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      facilityName: null,
      residentName: null,
      woundType: null,
      facilityResidentList: [],
      residentWoundList: [],
      wound: { residentId: null, woundId: null, fromDate: "", toDate: "" },
      summary: { patientName: '', providerName: '', woundLocation: '', woundType: '', reportGeneratedDate: null },
      reportRows: [],
      showReport: false
    });
  }

  renderWoundForm() {
    return (
      <>{
        (this.state.IsLoading == true) ?
          <form onSubmit={e => this.handleSubmit(e)}>
            <div className='row'>
              <div className='col-lg-4'>
                <div className="form-group">
                  <label className="form-label" htmlFor="FacilityName">Facility Name</label>
                  <Select
                    options={this.state.facilityList}
                    id="facilityId"
                    name="facilityId"
                    required
                    isSearchable
                    isClearable
                    filterOption={createFilter({ matchFrom: 'start' })}
                    onChange={(value) => {
                      this.onFacilitiChange(value)
                    }}
                    value={this.state.facilityName}
                  // onChange={e => setFacilitySelected({ value: e?.value, label: e?.label })}
                  />
                </div>
                {/* <div className="form-group">
                  <label className="form-label" for="FacilityName">Facility Name</label>

                  <select className="form-control form-control-sm"
                    id="facilityId"
                    name="facilityId"
                    required
                    onChange={e => this.onFacilitiChange(e)}
                    value={Common.replaceNullWithString(this.state.wound.facilityId)}
                  >
                    <option></option>
                    {this.state.facilityList}
                  </select>
                </div> */}
              </div>
              <div className='col-lg-4'>
                <div className="form-group">
                  <label className="form-label" htmlFor="ResidentId">Resident Name</label>
                  <Select
                    options={this.state.facilityResidentList}
                    id="residentId"
                    name="residentId"
                    required
                    isSearchable
                    isClearable
                    filterOption={createFilter({ matchFrom: 'start' })}
                    onChange={(value) => {

                      this.onResidentChange(value)
                    }}
                    value={this.state.residentName}
                  // onChange={e => setFacilitySelected({ value: e?.value, label: e?.label })}
                  />
                </div>
                {/* <div className="form-group">
                  <label className="form-label" for="FacilityName">Facility Name</label>

                  <select className="form-control form-control-sm"
                    id="facilityId"
                    name="facilityId"
                    required
                    onChange={e => this.onFacilitiChange(e)}
                    value={Common.replaceNullWithString(this.state.wound.facilityId)}
                  >
                    <option></option>
                    {this.state.facilityList}
                  </select>
                </div> */}
              </div>
              {/* <div className='col-lg-4'>
                <div className="form-group">
                  <label className="form-label" for="PatientName">Resident Name</label>
                  <select className="form-control form-control-sm"
                    id="residentId"
                    name="residentId"
                    onChange={e => this.onResidentChange(e)}
                    value={Common.replaceNullWithString(this.state.wound.residentId)}
                  >
                    <option></option>
                    {this.state.facilityResidentList}
                  </select>
                </div>
              </div> */}

              <div className='col-lg-4'>
                <div className="form-group">
                  <label className="form-label" htmlFor="WoundId">Wound</label>
                  <Select
                    options={this.state.residentWoundList}
                    id="woundId"
                    name="woundId"
                    required
                    isSearchable
                    isClearable
                    filterOption={createFilter({ matchFrom: 'start' })}
                    onChange={(e) => {
                      this.setState({ woundType: e, wound: { ...this.state.wound, woundId: e ? e.value : null } });
                    }}
                    value={this.state.woundType}
                  // onChange={e => setFacilitySelected({ value: e?.value, label: e?.label })}
                  />
                </div>
                {/* <div className="form-group">
                  <label className="form-label" for="FacilityName">Facility Name</label>

                  <select className="form-control form-control-sm"
                    id="facilityId"
                    name="facilityId"
                    required
                    onChange={e => this.onFacilitiChange(e)}
                    value={Common.replaceNullWithString(this.state.wound.facilityId)}
                  >
                    <option></option>
                    {this.state.facilityList}
                  </select>
                </div> */}
              </div>
              {/* <div className='col-lg-4'>
                <div className="form-group">
                  <label className="form-label" for="WoundType">Wound </label>
                  <select className="form-control form-control-sm"
                    id="woundId"
                    name="woundId"
                    // onChange={e => this.onWoundTypeChange(e)}
                    onChange={e => Common.updateInputValueInState(this.state.wound, e, this, this.state)}

                    value={Common.replaceNullWithString(this.state.wound.woundId)}
                  >
                    <option></option>
                    {this.state.residentWoundList}
                  </select>
                </div>
              </div> */}
              <div className='col-lg-4'>
                <div className="form-group">
                  <label className="form-label" htmlFor="FromDate">From Date</label>
                  <input type='date' id='FromDate'
                    name="fromDate"
                    min='1900-01-01'
                    max="3999-12-31"
                    required
                    value={this.state.wound.fromDate}
                    onChange={e => {
                      this.setState({ wound: { ...this.state.wound, fromDate: e.target.value } })

                    }}

                    // Common.updateInputValueInState(this.state.wound, e, this, this.state)}


                    className="form-control form-control-sm" />
                </div>
              </div>
              <div className='col-lg-4'>
                <div className="form-group">
                  <label className="form-label" htmlFor="ToDate">To Date</label>
                  <input type='date' id='ToDate'
                    name="toDate"
                    min={this.state.wound.fromDate || '1900-01-01'}
                    max="3999-12-31"
                    required
                    value={this.state.wound.toDate}
                    onChange={(e) => this.setState({ wound: { ...this.state.wound, toDate: e.target.value } })}
                    className="form-control form-control-sm" />
                </div>
              </div>

            </div>
            <div className='d-flex justify-content-end py-3'>
              <Button
                type='submit'
                variant="success"
                className="mr-5 px-10"
                size="sm"
                disabled={!this.state.facilityName || !this.state.residentName || !this.state.woundType || !this.state.wound.fromDate || !this.state.wound.toDate || this.state.wound.fromDate > this.state.wound.toDate}
              >
                Generate Report
              </Button>
              <button type="button" className='btn btn-danger btn-sm' onClick={(e) => this.handleClearFilters(e)}>Clear Filters</button>
            </div>
          </form> :
          <div className="d-flex justify-content-center">
            <Loader
              type="Puff"
              color="#00BFFF"
              height={50}
              width={50}
            />
          </div>
      }
      </>
    );
  }
  render() {
    const self = this;
    async function PrintElem(state) {
      const elm = document.getElementById('wound-trend-print');
      if (!elm) return;
      const doc = new jsPDF('p', 'pt', 'a4', false);
      await html2canvas(elm, { scale: 2 }).then((canvasItem) => {
        const pixelHeight = 1600 * 2;
        for (let i = 0; i <= elm.clientHeight * 2; i += pixelHeight) {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          canvas.width = canvasItem.width;
          canvas.height = Math.min(pixelHeight, elm.clientHeight * 2 - i);
          ctx.drawImage(canvasItem, 0, i, canvasItem.width, canvas.height, 0, 0, canvasItem.width, canvas.height);
          const imgData = canvas.toDataURL('image/png');
          doc.addImage(imgData, 'PNG', 10, 30, 575, 0, undefined, 'FAST');
          if (i + pixelHeight < elm.clientHeight * 2) doc.addPage();
        }
      });
      const pageCount = doc.internal.getNumberOfPages();
      doc.setFontSize(8);
      doc.setTextColor(112, 108, 108);
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.text('Page ' + i + ' of ' + pageCount, doc.internal.pageSize.width - 50, doc.internal.pageSize.height - 20);
      }
      doc.save(`${state.facilityForPDFName || 'Wound Trend'} - Wound Area Trend Report.pdf`);
    }

    const { summary, reportRows, selectedMetric } = this.state;
    const hasPushData = reportRows.some((r) => r.pushScore != null);
    const chartData = reportRows;

    return (
      <>
        <Card>
          <CardHeader className='Text-center' title='Wound Area Trend Report'>
            <CardHeaderToolbar><div className="example-tools" /></CardHeaderToolbar>
          </CardHeader>
          <CardBody>
            {this.renderWoundForm()}
            <hr />
            {this.state.showReport && (
              <>
                <div className='row'>
                  <div className='col-12'>
                    <button type="button" onClick={() => PrintElem(this.state)} className="mr-3 btn btn-success btn-sm float-right">Print Report</button>
                  </div>
                </div>
                <div className='trend-report'>
                  <div id="wound-trend-print" className='trend-report_content'>
                    <h2 className='text-center mb-10 mt-5 text-primary'>Wound Area Trend Report</h2>
                    <div className='border border-dark px-3 pt-3'>
                      <table className='table border-0 table-sm trendReportInfo'>
                        <tbody className='font-weight-bolder'>
                          <tr><td>Patient Name:</td><td>{summary.patientName || 'N/A'}</td></tr>
                          <tr><td>Provider Name:</td><td>{summary.providerName || 'N/A'}</td></tr>
                          <tr><td>Wound Location:</td><td>{summary.woundLocation || 'N/A'}</td></tr>
                          <tr><td>Wound Type:</td><td>{summary.woundType || 'N/A'}</td></tr>
                          <tr><td>Report Generated Date:</td><td>{summary.reportGeneratedDate ? Common.getInputStringDateUsingMoment2(summary.reportGeneratedDate) : 'N/A'}</td></tr>
                        </tbody>
                      </table>
                    </div>
                    {reportRows.length === 0 ? (
                      <div className='mt-5 py-5 text-center text-muted' role="status">
                        No assessments found in the selected date range.
                      </div>
                    ) : (
                      <>
                        <div className='mt-4'>
                          <table className='table table-bordered table-sm w-100'>
                            <thead>
                              <tr>
                                <th>Date of assessment</th>
                                <th>Length</th>
                                <th>Width</th>
                                <th>Calculated Area</th>
                                <th>PUSH Score</th>
                              </tr>
                            </thead>
                            <tbody>
                              {reportRows.map((r) => (
                                <tr key={uuid()}>
                                  <td>{r.dateLabel}</td>
                                  <td>{r.length}</td>
                                  <td>{r.width}</td>
                                  <td>{typeof r.area === 'number' ? r.area.toFixed(2) : r.area}</td>
                                  <td>{r.pushScore != null ? r.pushScore : 'N/A'}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                        <div className='mt-4'>
                          <label className="form-label mr-2">Graph metric:</label>
                          <div className="d-inline-block">
                            <label className="mr-3"><input type="radio" name="trendMetric" checked={selectedMetric === 'area'} onChange={() => self.setState({ selectedMetric: 'area' })} className="mr-1" /> Area</label>
                            <label><input type="radio" name="trendMetric" checked={selectedMetric === 'pushScore'} onChange={() => self.setState({ selectedMetric: 'pushScore' })} className="mr-1" /> PUSH Score</label>
                          </div>
                        </div>
                        {selectedMetric === 'pushScore' && !hasPushData ? (
                          <div className='mt-3 py-3 text-center text-muted'>No PUSH Score data available for the selected range.</div>
                        ) : (
                          <ResponsiveContainer width="100%" height={300} className="mt-3">
                            <LineChart data={chartData} margin={{ top: 10, right: 30, left: 0, bottom: 10 }}>
                              <CartesianGrid strokeDasharray="3 3" />
                              <XAxis dataKey="dateLabel" />
                              <YAxis />
                              <Tooltip />
                              <Line type="monotone" dataKey={selectedMetric} stroke="#3699FF" connectNulls={false} />
                            </LineChart>
                          </ResponsiveContainer>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </>
            )}
          </CardBody>
        </Card>
      </>
    );
  }
}